import { Feature, Polygon } from 'geojson'
import { latLngToCell, cellToBoundary, gridDisk } from 'h3-js'

export interface H3HexagonOptions {
  resolution: number // H3 resolution (fixed at 10)
  kRingDistance: number // Distance for kRing (number of rings around center)
}

export function generateH3Hexagons(
  lat: number,
  lng: number,
  options: H3HexagonOptions,
): Feature<Polygon>[] {
  const { resolution, kRingDistance } = options

  // Get the H3 index for the center point
  const centerH3Index = latLngToCell(lat, lng, resolution)

  // Get all hexagons within kRing distance
  const hexagonIndices = gridDisk(centerH3Index, kRingDistance)

  // Convert each H3 index to a GeoJSON polygon
  const hexagonFeatures: Feature<Polygon>[] = hexagonIndices.map((h3Index) => {
    const boundary = cellToBoundary(h3Index)

    // Convert boundary to GeoJSON polygon coordinates
    // Close the polygon by adding the first point at the end
    const coordinates = [
      [...boundary.map(([lat, lng]) => [lng, lat]), [boundary[0][1], boundary[0][0]]],
    ]

    return {
      type: 'Feature',
      id: h3Index,
      geometry: {
        type: 'Polygon',
        coordinates,
      },
      properties: {
        h3Index,
        resolution,
        isCenter: h3Index === centerH3Index,
      },
    }
  })

  return hexagonFeatures
}
